import React from 'react';

type Props = {
  width: string
}

export const DisplaySvg = (props: Props): React.ReactElement => {
  return <svg xmlns="http://www.w3.org/2000/svg" width={props.width} viewBox="0 0 115 85">
    <g id="Group_8" data-name="Group 8" transform="translate(-144 -297)">
      <g id="Group_7" data-name="Group 7" transform="translate(-111 -56)">
        <text id="_1" data-name="1" transform="translate(274 408)" fill="#ef7f1a" fontSize="45"
          fontFamily="SegoeUI-Bold, Segoe UI" fontWeight="700">
          <tspan x="0" y="0">1</tspan>
        </text>
        <text id="R3" transform="translate(314 408)" fill="#ef7f1a" fontSize="25"
          fontFamily="SegoeUI-Bold, Segoe UI" fontWeight="700">
          <tspan x="0" y="0">R3</tspan>
        </text>
      </g>
      <line id="Line_20" data-name="Line 20" x2="79" transform="translate(163.5 379.5)" fill="none"
        stroke="#1e3050" strokeLinecap="round" strokeWidth="5"/>
      <g id="Rectangle_89" data-name="Rectangle 89" transform="translate(144 297)" fill="none" stroke="#1e3050"
        strokeWidth="5">
        <rect width="115" height="74" rx="10" stroke="none"/>
        <rect x="2.5" y="2.5" width="110" height="69" rx="7.5" fill="none"/>
      </g>
    </g>
  </svg>

}
